import React from "react";
import Slider from "react-slick"
import Icons from "../../../myIcon/Icons";

export default function HumanBenefits({data}) {

  var settings = {
    dots: true,
    slidesToShow: 3,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: true,
    cssEase: "linear",
    autoplaySpeed: 1400,
    speed: 1500,

    prevArrow: (
      <button className="slick-arrow slick-prev">
        <Icons name="Longarrow_left"/>
      </button>
    ),
    nextArrow: (
      <button className="slick-arrow slick-next">
        <Icons name="Longarrow_right"/>
      </button>
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
        },
      },],
  };

  return (
    <>
      <section className="human-benefits-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h4 className="heading">{data?.head}</h4>
            </div>

            <div className="col-lg-12">
              <Slider {...settings}>
                {
                  data?.slides?.map((item, index) => (
                    <div key={index} className={`human-benefits-cards ${data?.boxClass}`}>
                      <img src={item?.img} alt="Human Benefit" />
                      <span>{item?.label}</span>
                      <p>{item?.desc}</p>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}